import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Link from "next/link";
import * as s from "./index.module.scss";
import secondaryFont from "@/utils/secondaryFont";
import { PrismicRichText } from "@prismicio/react";

const Media = ({ title, caption, description, blogs }) => {
  return (
    <section className={`section-center ${s.media_coverage}`}>
      <Container>
        <div className={s.header}>
          <h5 className="medium">{caption || ""}</h5>
          <h1 className="heading">{title || ""}</h1>
          <div className="fw-normal">
            <PrismicRichText field={description || []} />
          </div>
        </div>
        <div>
          {blogs?.map(
            ({ image, title, categoryTitle, date, text, buttonLink }, idx) => {
              return (
                <Link href={`/media-coverage/${buttonLink}`} key={idx}>
                  <Row key={idx} className={s.single_media}>
                    <Col xs={12} md={6} lg={5} xxl={4} className="mb-4 mb-md-0">
                      <img
                        loading="lazy"
                        src={image.url}
                        alt={image.alt || "image"}
                        className={s.image_side}
                      />
                    </Col>
                    <Col xs={12} md={6} lg={7} xxl={6}>
                      <h4 className="heading fw-bold">{title}</h4>
                      <div className={s.filters}>
                        {categoryTitle && (
                          <div className={s.category}>
                            <p className={`${secondaryFont} paragraph`}>
                              <span>{categoryTitle}</span>
                            </p>
                          </div>
                        )}
                        <div>
                          <p className={`${secondaryFont} paragraph`}>{date}</p>
                        </div>
                      </div>
                      <div className="d-none d-md-block">
                        <div className={`${secondaryFont} parapraph`}>
                          <PrismicRichText field={text || []} />
                        </div>
                      </div>
                      <Link
                        className="btn btn-outline-dark mt-4 d-none d-md-inline-flex"
                        href={`/media-coverage/${buttonLink}`}
                      >
                        View More
                      </Link>
                    </Col>
                  </Row>
                </Link>
              );
            },
          )}
        </div>
      </Container>
    </section>
  );
};

export default Media;
